import {
  SET_RECEITAS_PROPRIAS,
  SET_DETALHAMENTO_DESPESAS,
  SET_GRUPO_DESPESAS,
  SET_ADIANTAMENTOS,
  SET_FUNCAO_SUBFUNCAO,
  SET_DESPESAS_DETALHADAS,
  SET_ANO_BASE,
  DESPESAS_TOGGLE_LOADING
} from './types'

export const mutations = {
  [SET_RECEITAS_PROPRIAS] (state, payload) {
    state.receitas_proprias = payload.receitas_proprias
  },

  [SET_DETALHAMENTO_DESPESAS] (state, payload) {
    state.detalhamento_despesas = payload.detalhamento_despesas
  },

  [SET_GRUPO_DESPESAS] (state, payload) {
    state.grupo_despesas = payload.despesas_acao
  },

  [SET_FUNCAO_SUBFUNCAO] (state, payload) {
    state.funcao_subfuncao = payload.despesas_acao
  },

  [SET_ADIANTAMENTOS] (state, payload) {
    state.adiantamentos = payload.adiantamentos
  },

  [SET_DESPESAS_DETALHADAS] (state, payload) {
    state.despesas_detalhadas = payload.despesas_detalhadas
  },

  [SET_ANO_BASE] (state, payload) {
    state.ano_base = payload
  },

  [DESPESAS_TOGGLE_LOADING] (state) {
    state.loading = !state.loading
  },
}



// WEBPACK FOOTER //
// ./src/store/modules/receitas_despesas/mutations.js